
<template>
  <div id="footer">
    <div class="footer-top-wrap">
      <FooterTop />
    </div>
    <FooterMap @trigger-lang="triggerLang" />
    <FooterLetter />
    <FooterBottom />
  </div>
</template>

<script>
import FooterTop from '@/components/FooterTop.vue'
import FooterMap from '@/components/FooterMap.vue'
import FooterLetter from '@/components/FooterLetter.vue'
import FooterBottom from '@/components/FooterBottom.vue'

export default {
  components: {
    FooterTop,
    FooterMap,
    FooterLetter,
    FooterBottom
  },

  methods: {
    triggerLang () {
      this.$emit('trigger-lang')
    }
  }
}
</script>
